import React from "react";
import { Outlet } from "react-router-dom";

//FUNCTION
const HrRoutes = () => {
    return (
        <>
            <Outlet />
        </>
    )
}

export default HrRoutes;